import { patientAppStores } from '@/features/okdoc/config';

export function PatientAppFooter() {
  return (
    <div className="bg-black px-5 py-6 sm:px-8">
      <div className="mx-auto max-w-sm rounded-xl bg-white px-3 py-3">
        <p className="mb-2 text-center text-[10px] font-semibold uppercase tracking-[0.16em] text-gray-500">
          Приложение для пациентов
        </p>
        <div className="flex flex-wrap items-center justify-center gap-2">
          {patientAppStores.map((store) => (
            <a
              key={store.id}
              href={store.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex"
              title={store.title}
            >
              <img
                src={store.image}
                alt={store.title}
                className="h-10 w-auto"
                width={store.width}
                height={store.height}
              />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
